export enum CarModel {
    Small = 'small',
    Family = 'family',
    StationCar = 'stationCar',
    SevenSeats = 'sevenSeats',
    Other = 'other'
}